import React, { useState } from "react"
import { GridGallery } from "./gallery/grid-gallery"
import { FeaturedGallery } from "./gallery/featured-gallery"
import { FileGallery } from "core/file-gallery"
import { useChildElements } from "../utils/use-child-elements"
import { SettingsButton } from "./settings-button"
import "./gallery-element.css"

// This hook separates the file gallery logic from the image gallery. It is
// still highly specific to this use case.
function useFileGallery(element_id) {
  const [active, setActive] = useState(false)
  const { addChild } = useChildElements("parent_element_id", element_id)

  const open = () => setActive(true)

  const close = file => {
    if (file?.dataURL) {
      addChild({
        type: "Image",
        upload_file_name: file.filename,
        src: file.dataURL,
        alt: file.alt
      })
    }
    setActive(false)
  }

  return { active, open, close }
}

export function ImageGallery({ element_id, ...props }) {
  const fileGallery = useFileGallery(element_id)
  const { children: images } = useChildElements("parent_element_id", element_id)
  const { layout, editing } = props

  const styles = {
    fontSize: `${props.captionSize}px`,
    fontWeight: props.captionWeight,
    color: props.captionColor
  }

  const galleryProps = {
    images,
    settings: props,
    addImage: fileGallery.open,
    style: styles
  }

  return (
    <div className="my-4">
      {editing && (
        <div className="flex justify-between items-center mb-4">
          <div className="font-sans text-gray-700 font-semibold text-base">
            Image gallery
          </div>
          <SettingsButton onClick={props.onClick} />
        </div>
      )}
      {layout === "grid" && <GridGallery {...galleryProps} />}
      {layout === "featured" && <FeaturedGallery {...galleryProps} />}
      <FileGallery
        active={fileGallery.active}
        onClose={fileGallery.close}
        allowedFileTypes={["image"]}
      />
    </div>
  )
}

ImageGallery.componentType = "Gallery"
